import { IHomepageSections } from '@/interfaces/homepage';
import useHeaderStore from '@/store/header';
import React, { memo, useEffect } from 'react';

const CloseHomePageClientComponent = memo(function CloseHomePageClientComponent({ homePageSections }: { homePageSections: IHomepageSections }) {
  const setNavbarBackgroundColor = useHeaderStore((state) => state.setNavbarBackgroundColor);
  const setNavbarTextColor = useHeaderStore((state) => state.setNavbarTextColor);

  useEffect(() => {
    // background-color: ${homePageSection?.PreKeyBanner?.[0]?.Items[0]?.NavbarBackgroundColor ?? 'transparent'};
    // color: ${homePageSection?.PreKeyBanner?.[0]?.Items[0]?.NavbarTextColor ?? 'black'};
    if (homePageSections?.PreKeyBanner?.[0]?.Items[0]?.NavbarBackgroundColor) {
      // console.log(homePageSections.PreKeyBanner[0].Items[0].NavbarBackgroundColor, 'homePageSections.PreKeyBanner[0].Items[0].NavbarBackgroundColor');
      setNavbarBackgroundColor(homePageSections.PreKeyBanner[0].Items[0].NavbarBackgroundColor);
    }
    if (homePageSections?.PreKeyBanner?.[0]?.Items[0]?.NavbarTextColor) {
      setNavbarTextColor(homePageSections.PreKeyBanner[0].Items[0].NavbarTextColor);
    }
  }, [homePageSections]);
  return <></>;
});

export default CloseHomePageClientComponent;
